var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 160,
    viewBox: "0 0 165 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 81L67.5 69",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 81L55.5 69",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 81L111.5 69",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 81L99.5 69",
    stroke: "#053668",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.5 30H18.5C16.2909 30 14.5 31.7909 14.5 34V122C14.5 124.209 16.2909 126 18.5 126H148.5C150.709 126 152.5 124.209 152.5 122V34C152.5 31.7909 150.709 30 148.5 30Z",
    stroke: "#053668",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 82.5,
    cy: 130,
    rx: 82,
    ry: 4,
    fill: "#053668"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 95C94.0109 92.2808 90.2458 90.3831 85.5 90.0517M72.5 95C73.2038 93.7148 74.4161 92.6131 76 91.7736M76 91.7736C78.1133 90.6534 80.8883 90 84 90C84.5095 90 85.01 90.0175 85.5 90.0517M76 91.7736C75.8333 94.0157 76.5 98.5 80.5 98.5C84.5 98.5 85.5 92.8678 85.5 90.0517",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 33C14.5 31.3431 15.8431 30 17.5 30H149.5C151.157 30 152.5 31.3431 152.5 33V39H14.5V33Z",
    fill: "#053668"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 34,
    r: 2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 34,
    r: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 34,
    r: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.26917efe126e613725b59ce672980214.svg";
export { ForwardRef as ReactComponent };